import { MainV3ApiBase } from './base';
import { ApplicationPageKey, ApplicationPage } from '../types/applicationPages';
import { EditableUser } from '../containers/application/states/UserFormState';
import { OrderIndexView } from '../types/orders';
import { LocationId } from '../../commonv3/types/locations';
import { UserAddress } from '../types/userAddresses';

export type ApplicationPageRequest = {
  user?: EditableUser;
  user_address?: UserAddress;
  card?: { token: string };
  entrance_installments: number;
  effective_date?: string;
  coupon_code?: string;
  home_location_id?: LocationId;
};

export type ApplicationPageResponse = {
  orders: OrderIndexView[];
};

export const ApplicationPageApis = {
  base() {
    return MainV3ApiBase.appendPath('application_pages');
  },
  show(id: ApplicationPageKey, user_email?: string, coupon_code?: string): Promise<ApplicationPage> {
    return this.base().withId(id).get({ email: user_email, coupon_code: coupon_code });
  },
  apply(id: ApplicationPageKey, request: ApplicationPageRequest): Promise<ApplicationPageResponse> {
    return this.base().withId(id).appendPath('apply').post(request);
  },
};
